import _toConsumableArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useId, Link, Heading, LinkHeading, Callout, Image, ProductImage, AspectRatio, Code, InvertTheme, Tabs, TabList, Tab, TabPanels, TabPanel, Box, Flex, Icon, Popover, Button, Prose } from '@stoplight/mosaic';
import { ErrorBoundary } from '@stoplight/react-error-boundary';
import * as React from 'react';
import React__default, { useMemo, createElement, Fragment } from 'react';
import { parse as parse$1, remarkParsePreset } from '@stoplight/markdown';
import { CodeViewer } from '@stoplight/mosaic-code-viewer';
import deepmerge from 'deepmerge';
import { sanitize as sanitize$1, defaultSchema } from 'hast-util-sanitize';
import remarkParse from 'remark-parse';
import unified from 'unified';
import { u } from 'unist-builder';
import { raw } from 'hast-util-raw';
import { toH } from 'hast-to-hyperscript';
import { visit } from 'unist-util-visit';
import { toHast } from 'mdast-util-to-hast';
import { h } from 'hastscript';
import { selectAll } from 'unist-util-select';
import useComponentSize from '@rehooks/component-size';
var EMPTY_OBJ$4 = {};

var useMarkdown2Mdast = function useMarkdown2Mdast(markdownOrTree) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJ$4;
  return React__default.useMemo(function () {
    var options = {
      components: opts.components,
      remarkPlugins: opts.remarkPlugins,
      settings: opts.settings
    };

    if (typeof markdownOrTree === 'string') {
      return parse$1(markdownOrTree, options);
    }

    return markdownOrTree;
  }, [markdownOrTree, opts.components, opts.remarkPlugins, opts.settings]);
};

var EMPTY_OBJ$3 = {};
var defaultContext = EMPTY_OBJ$3;
var MarkdownViewerContext = React__default.createContext(undefined);
MarkdownViewerContext.displayName = 'MarkdownViewerContext';

var useMarkdownViewer = function useMarkdownViewer() {
  var _a;

  return (_a = React__default.useContext(MarkdownViewerContext)) !== null && _a !== void 0 ? _a : defaultContext;
};

var MarkdownViewerProvider = function MarkdownViewerProvider(_ref) {
  var children = _ref.children,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? EMPTY_OBJ$3 : _ref$components,
      value = _objectWithoutProperties(_ref, ["children", "components"]);

  var parentValue = useMarkdownViewer();
  var parentComponents = parentValue.components || EMPTY_OBJ$3;
  var newComponents = useMemo(function () {
    return Object.assign({}, parentComponents, components);
  }, [components, parentComponents]);
  var newContextValue = useMemo(function () {
    return Object.assign({}, parentValue, {
      components: newComponents
    }, value);
  }, [newComponents, parentValue, value]);
  return React__default.createElement(MarkdownViewerContext.Provider, {
    value: newContextValue
  }, children);
};

var isServer = typeof document === 'undefined';

var loadMermaid = function loadMermaid(id, scriptUrl) {
  if (isServer) return;
  var existing = document.head.querySelector('#' + id);

  if (!existing) {
    var scriptNode = document.createElement('script');
    scriptNode.src = scriptUrl;
    scriptNode.id = id;
    scriptNode.crossOrigin = '';
    document.body.appendChild(scriptNode);

    scriptNode.onload = function () {
      var m = mermaid;

      if (m) {
        m.initialize({
          startOnLoad: false,
          sequence: {
            diagramPadding: 0,
            showSequenceNumbers: true
          },
          er: {
            diagramPadding: 0
          },
          flowchart: {
            diagramPadding: 0
          },
          journey: {
            diagramPadding: 0
          }
        });

        m.parseError = function (err) {
          console.error("Mermaid parsing error: ".concat(String(err)), err);
        };

        document.dispatchEvent(new CustomEvent('mermaid.loaded'));
      } else {
        console.warn("Could not load mermaid.js script from ".concat(scriptUrl));
      }
    };
  }
};

var loaded = false;

var useLoadMermaid = function useLoadMermaid(scriptUrl) {
  if (!loaded) {
    loaded = true;
    loadMermaid('mermaid-loader', scriptUrl);
  }
};

var DEFAULT_MERMAID_SCRIPT_URL = 'https://unpkg.com/mermaid@8.14.0/dist/mermaid.min.js';

var useRenderMermaid = function useRenderMermaid(id, chartValue, containerRef, loaded) {
  var _useMarkdownViewer = useMarkdownViewer(),
      _useMarkdownViewer$me = _useMarkdownViewer.mermaidScriptUrl,
      mermaidScriptUrl = _useMarkdownViewer$me === void 0 ? DEFAULT_MERMAID_SCRIPT_URL : _useMarkdownViewer$me;

  useLoadMermaid(mermaidScriptUrl);
  React.useEffect(function () {
    var mermaid = window.mermaid;

    if (loaded && mermaid && containerRef.current) {
      mermaid.render(id, chartValue, function (el) {
        if (containerRef.current) {
          containerRef.current.innerHTML = el;
        }
      }, containerRef.current);
    }
  }, [chartValue, containerRef, id, loaded]);
};

var mermaidLoaded = false;

var MermaidBlock = function MermaidBlock(_ref2) {
  var chartValue = _ref2.chartValue;
  var id = useId();
  var containerRef = React.useRef(null);

  var _React$useState = React.useState(mermaidLoaded),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loaded = _React$useState2[0],
      setLoaded = _React$useState2[1];

  useRenderMermaid(id, chartValue, containerRef, loaded);
  React.useEffect(function () {
    if (!mermaidLoaded) {
      var handler = function handler() {
        mermaidLoaded = true;
        setLoaded(true);
      };

      document.addEventListener('mermaid.loaded', handler);
      return function () {
        return document.removeEventListener('mermaid.loaded', handler);
      };
    }

    return;
  }, []);
  return React.createElement("div", {
    className: "mermaid",
    ref: containerRef
  }, chartValue);
};

var getCodeLanguage = function getCodeLanguage(lang) {
  switch (lang) {
    case 'http':
      return 'yaml';

    default:
      return lang;
  }
};

var DefaultSMDComponents = {
  a: function a(_ref3) {
    var href = _ref3.href,
        color = _ref3.color,
        props = _objectWithoutProperties(_ref3, ["href", "color"]);

    if (typeof href !== 'string') return null;

    if (href.startsWith('/') || href.startsWith('#')) {
      return React__default.createElement(Link, _objectSpread({
        href: href,
        color: color
      }, props));
    }

    return React__default.createElement(Link, _objectSpread({
      href: href,
      color: color,
      target: "_blank",
      rel: "noopener noreferrer"
    }, props));
  },
  h1: function h1(_ref4) {
    var color = _ref4.color,
        props = _objectWithoutProperties(_ref4, ["color"]);

    return React__default.createElement(Heading, _objectSpread({
      size: 1
    }, props));
  },
  h2: function h2(_ref5) {
    var color = _ref5.color,
        props = _objectWithoutProperties(_ref5, ["color"]);

    return React__default.createElement(LinkHeading, _objectSpread({
      size: 2
    }, props));
  },
  h3: function h3(_ref6) {
    var color = _ref6.color,
        props = _objectWithoutProperties(_ref6, ["color"]);

    return React__default.createElement(LinkHeading, _objectSpread({
      size: 3
    }, props));
  },
  h4: function h4(_ref7) {
    var color = _ref7.color,
        props = _objectWithoutProperties(_ref7, ["color"]);

    return React__default.createElement(LinkHeading, _objectSpread({
      size: 4
    }, props));
  },
  h5: function h5(_ref8) {
    var color = _ref8.color,
        props = _objectWithoutProperties(_ref8, ["color"]);

    return React__default.createElement(Heading, _objectSpread({
      size: 4
    }, props));
  },
  h6: function h6(_ref9) {
    var color = _ref9.color,
        props = _objectWithoutProperties(_ref9, ["color"]);

    return React__default.createElement(Heading, _objectSpread({
      size: 4
    }, props));
  },
  blockquote: function blockquote(_ref10) {
    var theme = _ref10.theme,
        children = _ref10.children;
    var intent = 'default';
    if (theme !== 'info') intent = theme;
    return React__default.createElement(Callout, {
      appearance: "outline",
      intent: intent,
      as: "blockquote"
    }, children);
  },
  img: function img(_ref11) {
    var src = _ref11.src,
        _color = _ref11.color,
        bg = _ref11.bg,
        focus = _ref11.focus,
        inline = _ref11.inline,
        invertOnDark = _ref11.invertOnDark,
        props = _objectWithoutProperties(_ref11, ["src", "color", "bg", "focus", "inline", "invertOnDark"]);

    if (!src) {
      console.warn('[MarkdownViewer]: img skipped because `src` is empty.');
      return null;
    }

    if (inline !== void 0 || focus === 'false' || 'style' in props) {
      return React__default.createElement(Image, _objectSpread({
        src: src
      }, props, {
        invertOnDark: invertOnDark !== void 0
      }));
    }

    return React__default.createElement(ProductImage, {
      bg: bg,
      focus: focus
    }, React__default.createElement(Image, _objectSpread({
      src: src
    }, props, {
      invertOnDark: invertOnDark !== void 0
    })));
  },
  iframe: function iframe(_ref12) {
    var src = _ref12.src,
        props = _objectWithoutProperties(_ref12, ["src"]);

    if (src === null || src === void 0 ? void 0 : src.startsWith('https://open.spotify.com/embed')) {
      return React__default.createElement("iframe", _objectSpread({
        src: src
      }, props, {
        style: {
          height: src.includes('playlist') ? '400px' : '250px'
        }
      }));
    }

    return React__default.createElement(AspectRatio, {
      ratio: 16 / 9
    }, React__default.createElement("iframe", _objectSpread({
      src: src
    }, props)));
  },
  code: function code(_ref13) {
    var children = _ref13.children,
        inline = _ref13.inline,
        lineNumbers = _ref13.lineNumbers,
        title = _ref13.title,
        lang = _ref13.lang,
        rest = _objectWithoutProperties(_ref13, ["children", "inline", "lineNumbers", "title", "lang"]);

    if (inline !== void 0) {
      return React__default.createElement(Code, null, children);
    }

    if (lang === 'mermaid') {
      var chartValue = String(Array.isArray(children) ? children[0] : children);
      return React__default.createElement(ErrorBoundary, null, React__default.createElement(MermaidBlock, {
        chartValue: chartValue
      }));
    }

    return React__default.createElement(ErrorBoundary, null, React__default.createElement(InvertTheme, null, React__default.createElement(CodeViewer, _objectSpread({
      bg: "canvas",
      value: String(children),
      language: getCodeLanguage(String(lang)),
      rounded: "lg",
      ring: {
        focus: true
      },
      ringColor: "primary",
      ringOpacity: 50,
      showLineNumbers: lineNumbers !== void 0,
      title: title
    }, rest))));
  },
  tabs: function tabs(props) {
    return React__default.createElement(Tabs, {
      appearance: "line"
    }, React__default.createElement(TabList, null, React__default.Children.map(props.children, function (child, i) {
      return React__default.createElement(Tab, {
        key: i
      }, child.props.title);
    })), React__default.createElement(TabPanels, null, React__default.Children.map(props.children, function (child, i) {
      return React__default.createElement(TabPanel, {
        key: i
      }, child);
    })));
  },
  tab: function tab(_ref14) {
    var children = _ref14.children;
    return React__default.createElement(React__default.Fragment, null, children);
  },
  codegroup: function codegroup(props) {
    return React__default.createElement(Box, {
      className: "sl-code-group"
    }, React__default.createElement(Tabs, null, React__default.createElement(Flex, {
      alignItems: "center"
    }, React__default.createElement(Box, {
      mr: 4,
      ml: 1
    }, React__default.createElement(Icon, {
      icon: ['far', 'code'],
      size: "sm"
    })), React__default.createElement(TabList, {
      fontSize: "lg",
      density: "compact"
    }, React__default.Children.map(props.children, function (child, i) {
      var _a;

      return React__default.createElement(Tab, {
        key: i
      }, ((_a = child.props) === null || _a === void 0 ? void 0 : _a.lang) || 'untitled');
    }))), React__default.createElement(TabPanels, {
      p: 1
    }, React__default.Children.map(props.children, function (child, i) {
      return React__default.createElement(TabPanel, {
        key: i
      }, child);
    }))));
  }
};

function rehypeRaw(options, _settings) {
  return transform;

  function transform(tree, file) {
    return raw(tree, file, options);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var hastCssPropertyMap = {
  align: 'text-align',
  valign: 'vertical-align',
  height: 'height',
  width: 'width'
};

function tableCellStyle(node) {
  visit(node, 'element', visitor);
  return node;
}

function visitor(node) {
  if (node.tagName !== 'tr' && node.tagName !== 'td' && node.tagName !== 'th') {
    return;
  }

  var hastName;
  var cssName;

  for (hastName in hastCssPropertyMap) {
    if (!hasOwnProperty.call(hastCssPropertyMap, hastName) || node.properties[hastName] === undefined) {
      continue;
    }

    cssName = hastCssPropertyMap[hastName];
    appendStyle(node, cssName, node.properties[hastName]);
    delete node.properties[hastName];
  }
}

function appendStyle(node, property, value) {
  var prevStyle = (node.properties.style || '').trim();

  if (prevStyle && !/;\s*/.test(prevStyle)) {
    prevStyle += ';';
  }

  if (prevStyle) {
    prevStyle += ' ';
  }

  var nextStyle = prevStyle + property + ': ' + value + ';';
  node.properties.style = nextStyle;
}

var own = {}.hasOwnProperty;

function rehypeReact(options) {
  var settings = options || {};
  var createElement = settings.createElement;
  this.Compiler = compiler;

  function compiler(node) {
    var result = toH(h, tableCellStyle(node), settings.prefix);

    if (node.type === 'root') {
      result = result.type === 'div' && (node.children.length !== 1 || node.children[0].type !== 'element') ? result.props.children : [result];
      return createElement(settings.Fragment || 'div', {}, result);
    }

    return result;
  }

  function h(name, props, children) {
    var component = name;

    if (settings.components && own.call(settings.components, name)) {
      component = settings.components[name];

      if (settings.passNode) {
        props.node = this;
      }
    }

    return createElement(component, props, children);
  }
}

function remark2rehype(destination, options) {
  if (destination && !destination.process) {
    options = destination;
    destination = null;
  }

  return destination ? bridge(destination, options) : mutate(options);
}

function bridge(destination, options) {
  return transformer;

  function transformer(node, file, next) {
    destination.run(toHast(node, options), file, done);

    function done(error) {
      next(error);
    }
  }
}

function mutate(options) {
  return transformer;

  function transformer(node) {
    return toHast(node, options);
  }
}

function createIframeNode(props) {
  return h('iframe', _objectSpread({}, props, {
    seamless: true,
    style: 'width: 100%',
    width: '100%'
  }));
}

var customProviders = [{
  provider_name: 'CodePen',
  provider_url: 'https://codepen.io',
  handler: function handler(href) {
    if (!href.includes('/pen/')) return;
    return createIframeNode({
      sandbox: 'allow-scripts allow-same-origin',
      src: href.replace('/pen/', '/embed/')
    });
  }
}, {
  provider_name: 'GitHub',
  provider_url: 'https://gist.github.com',
  handler: function handler(href) {
    if (href === 'https://gist.github.com' || href === 'https://gist.github.com/discover') return;
    return createIframeNode({
      srcdoc: "<script src=\"".concat(href, ".js\"></script>\n<script>\n  const style = document.body.appendChild(document.createElement('style'));\n  style.textContent = `body { margin: 0; }\n.gist .gist-file { margin-bottom: 0 !important; `;\n  const offsetHeight = document.querySelector('.gist').offsetHeight;\n  window.frameElement.parentElement.style.height = `${offsetHeight}px`;\n</script>")
    });
  }
}, {
  provider_name: 'GIPHY',
  provider_url: 'https://giphy.com',
  handler: function handler(href) {
    var i = href.lastIndexOf('-');
    if (i === -1) return;
    var id = href.slice(i + 1);
    return createIframeNode({
      src: "https://giphy.com/embed/".concat(id).concat(href.includes('/clips/') ? '/video' : '')
    });
  }
}, {
  provider_name: 'Spotify',
  provider_url: 'https://open.spotify.com',
  handler: function handler(href) {
    if (href === 'https://open.spotify.com') return;
    return createIframeNode({
      src: href.replace('https://open.spotify.com/', 'https://open.spotify.com/embed/')
    });
  }
}, {
  provider_name: 'Figma',
  provider_url: 'https://www.figma.com',
  handler: function handler(href) {
    if (!href.startsWith('https://www.figma.com/file/')) return;
    return createIframeNode({
      sandbox: 'allow-scripts allow-same-origin',
      src: "https://www.figma.com/embed?embed_host=".concat(location.host, "&url=").concat(href)
    });
  }
}];
var providers = [{
  provider_name: 'Avocode',
  provider_url: 'https://www.avocode.com/',
  endpoints: [{
    schemes: ['https://app.avocode.com/view/*'],
    url: 'https://stage-embed.avocode.com/api/oembed'
  }]
}, {
  provider_name: 'Zeplin',
  provider_url: 'https://zeplin.io',
  endpoints: [{
    schemes: ['https://app.zeplin.io/project/*/screen/*', 'https://app.zeplin.io/project/*/screen/*/version/*', 'https://app.zeplin.io/project/*/styleguide/components?coid=*', 'https://app.zeplin.io/styleguide/*/components?coid=*'],
    url: 'https://app.zeplin.io/embed'
  }]
}, {
  provider_name: 'CodePen',
  provider_url: 'https://codepen.io',
  endpoints: [{
    schemes: ['http://codepen.io/*', 'https://codepen.io/*'],
    url: 'https://codepen.io/api/oembed'
  }]
}, {
  provider_name: 'CodeSandbox',
  provider_url: 'https://codesandbox.io',
  endpoints: [{
    schemes: ['https://codesandbox.io/s/*', 'https://codesandbox.io/embed/*'],
    url: 'https://codesandbox.io/oembed'
  }]
}, {
  provider_name: 'Replit',
  provider_url: 'https://repl.it/',
  endpoints: [{
    schemes: ['https://repl.it/@*/*', 'https://replit.com/@*/*'],
    url: 'https://repl.it/data/oembed',
    proxy: true
  }]
}, {
  provider_name: 'Runkit',
  provider_url: 'https://runkit.com',
  endpoints: [{
    schemes: ['https://runkit.com/*', 'http://embed.runkit.com/*,', 'https://embed.runkit.com/*,'],
    url: 'https://embed.runkit.com/oembed',
    formats: ['json']
  }]
}, {
  provider_name: 'GIPHY',
  provider_url: 'https://giphy.com',
  endpoints: [{
    schemes: ['https://giphy.com/gifs/*', 'https://giphy.com/clips/*', 'http://gph.is/*', 'https://media.giphy.com/media/*/giphy.gif'],
    url: 'https://giphy.com/services/oembed',
    discovery: true
  }]
}, {
  provider_name: 'Grain',
  provider_url: 'https://grain.co',
  endpoints: [{
    schemes: ['https://grain.co/highlight/*'],
    url: 'http://api.grain.co/_/api/oembed',
    proxy: true
  }]
}, {
  provider_name: 'Vimeo',
  provider_url: 'https://vimeo.com/',
  endpoints: [{
    schemes: ['https://vimeo.com/*', 'https://vimeo.com/album/*/video/*', 'https://vimeo.com/channels/*/*', 'https://vimeo.com/groups/*/videos/*', 'https://vimeo.com/ondemand/*/*', 'https://player.vimeo.com/video/*'],
    url: 'https://vimeo.com/api/oembed.json',
    discovery: true
  }]
}, {
  provider_name: 'YouTube',
  provider_url: 'https://www.youtube.com/',
  endpoints: [{
    schemes: ['https://*.youtube.com/watch*', 'https://*.youtube.com/v/*', 'https://youtu.be/*', 'https://*.youtube.com/playlist?list=*'],
    url: 'https://www.youtube.com/oembed'
  }]
}, {
  provider_name: 'SoundCloud',
  provider_url: 'http://soundcloud.com/',
  endpoints: [{
    schemes: ['http://soundcloud.com/*', 'https://soundcloud.com/*', 'https://soundcloud.app.goog.gl/*'],
    url: 'https://soundcloud.com/oembed'
  }]
}, {
  provider_name: 'Spotify',
  provider_url: 'https://spotify.com/',
  endpoints: [{
    schemes: ['https://open.spotify.com/*', 'spotify:*'],
    url: 'https://open.spotify.com/oembed/'
  }]
}, {
  provider_name: 'SlideShare',
  provider_url: 'http://www.slideshare.net/',
  endpoints: [{
    schemes: ['https://www.slideshare.net/*/*', 'http://www.slideshare.net/*/*', 'https://fr.slideshare.net/*/*', 'http://fr.slideshare.net/*/*', 'https://de.slideshare.net/*/*', 'http://de.slideshare.net/*/*', 'https://es.slideshare.net/*/*', 'http://es.slideshare.net/*/*', 'https://pt.slideshare.net/*/*', 'http://pt.slideshare.net/*/*'],
    url: 'https://www.slideshare.net/api/oembed/2',
    proxy: true
  }]
}, {
  provider_name: 'SpeakerDeck',
  provider_url: 'https://speakerdeck.com',
  endpoints: [{
    schemes: ['http://speakerdeck.com/*/*', 'https://speakerdeck.com/*/*'],
    url: 'https://speakerdeck.com/oembed.json',
    proxy: true
  }]
}, {
  provider_name: 'Twitter',
  provider_url: 'http://www.twitter.com/',
  endpoints: [{
    schemes: ['https://twitter.com/*/status/*', 'https://*.twitter.com/*/status/*', 'https://twitter.com/*/moments/*', 'https://*.twitter.com/*/moments/*'],
    url: 'https://publish.twitter.com/oembed',
    proxy: true
  }]
}];

function handleProxiedOEmbed(target, oembed) {
  if (oembed.type !== 'rich' && oembed.type !== 'video') {
    return;
  }

  switch (oembed.provider_name) {
    case 'Twitter':
      handleTwitter(target, oembed);
      break;

    case 'replit':
    case 'SlideShare':
    case 'Speaker Deck':
    case 'Grain':
      {
        var doc = new DOMParser().parseFromString(oembed.html, 'text/html');
        var iframe = doc.body.querySelector('iframe');

        if ((iframe === null || iframe === void 0 ? void 0 : iframe.childElementCount) !== 0 || !iframe.src.startsWith('https://replit.com/@') && !iframe.src.startsWith('https://www.slideshare.net/slideshow/embed_code') && !iframe.src.startsWith('https://speakerdeck.com/player/') && !iframe.src.startsWith('http://speakerdeck.com/player/') && !iframe.src.startsWith('https://grain.co/_/embed/')) {
          return;
        }

        var _iterator = _createForOfIteratorHelper([].slice.call(iframe.attributes)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attr = _step.value;

            if (attr !== 'src' && attr !== 'sandbox') {
              iframe.removeAttribute(attr);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        target.replaceWith(iframe);
        break;
      }
  }
}

function handleTwitter(target, oembed) {
  var doc = new DOMParser().parseFromString(oembed.html, 'text/html');

  var _iterator2 = _createForOfIteratorHelper([].slice.call(doc.body.querySelectorAll('body *'))),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var node = _step2.value;
      if (['P', 'BLOCKQUOTE', 'BR'].includes(node.tagName)) continue;

      switch (node.tagName) {
        case 'SCRIPT':
          if (node.src.startsWith('https://platform.twitter.com/')) {
            continue;
          }

          break;

        case 'A':
          {
            var url = new URL(node.href);
            if (['https://t.co', 'https://twitter.com'].includes(url.origin)) continue;
            break;
          }
      }

      throw new Error('Unknown content, aborting');
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  target.addEventListener('load', function () {
    if (!target.contentDocument) {
      return;
    }

    var style = document.createElement('style');
    style.textContent = "body { margin: 0; }.twitter-tweet { margin: 0 !important; }";
    target.contentDocument.body.appendChild(style);
    var observer = new MutationObserver(function (records) {
      var node;

      var _iterator3 = _createForOfIteratorHelper(records),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var record = _step3.value;

          if (record.type === 'childList' && (node = [].find.call(record.addedNodes, function (node) {
            return node.matches('div[class*="twitter-tweet-rendered"]');
          })) && node.firstElementChild) {
            observer.observe(node.firstElementChild, {
              attributes: true,
              attributeFilter: ['style']
            });
          } else if (record.type === 'attributes' && target.parentElement && record.target.style.height !== '0px') {
            target.parentElement.style.height = record.target.style.height;
            observer.disconnect();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
    var node = target.contentDocument.querySelector('div[class*="twitter-tweet-rendered"]');
    observer.observe(node !== null && node !== void 0 ? node : target.contentDocument.body, {
      childList: true
    });

    if (node === null || node === void 0 ? void 0 : node.firstElementChild) {
      observer.observe(node.firstElementChild, {
        attributes: true,
        attributeFilter: ['style']
      });
    }
  }, {
    once: true
  });
  target.srcdoc = oembed.html;
}

var SYMBOL_NAME = '@stoplight/markdown-viewer/oembed-runtime';
var SYMBOL = Symbol(SYMBOL_NAME);

var spawnRuntime = function spawnRuntime(window) {
  var document = window.document;
  var runtime = {
    createPhotoOEmbed: function createPhotoOEmbed(oembed) {
      var img = document.createElement('img');
      Object.assign(img, {
        src: oembed.url,
        width: oembed.width,
        height: oembed.height,
        alt: oembed.title
      });
      return img;
    },
    createVideoOEmbed: function createVideoOEmbed(oembed) {
      var _a;

      var doc = new DOMParser().parseFromString(oembed.html, 'text/html');
      var iframe = doc.querySelector('iframe');

      if (iframe === null) {
        iframe = document.createElement('iframe');
        iframe.srcdoc = oembed.html;
      }

      iframe.style.cssText += "width:100%;height:100%";
      Object.assign(iframe, {
        width: (_a = iframe.width) !== null && _a !== void 0 ? _a : '100%',
        height: iframe.height,
        referrerpolicy: 'no-referrer',
        seamless: true,
        sandbox: 'allow-scripts allow-same-origin'
      });
      return iframe;
    },
    handleProxiedOEmbed: handleProxiedOEmbed,
    processOEmbed: function processOEmbed(oembed, proxy) {
      if (!window.frameElement) {
        throw ReferenceError('window.frameElement not available');
      }

      if (proxy) {
        return this.handleProxiedOEmbed(window.frameElement, oembed);
      }

      switch (oembed.type) {
        case 'photo':
          window.frameElement.replaceWith(this.createPhotoOEmbed(oembed));
          break;

        case 'rich':
        case 'video':
          window.frameElement.replaceWith(this.createVideoOEmbed(oembed));
          break;

        case 'link':
        default:
          throw Error('OEmbed links are not supported');
      }
    },
    fetchOEmbed: function () {
      var _fetchOEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(href, proxy) {
        var url, res, json;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (proxy) {
                  url = new URL('https://api.allorigins.win/get');
                  url.searchParams.set('url', href);
                  href = url.href;
                }

                _context.next = 3;
                return fetch(href, {
                  mode: 'cors'
                });

              case 3:
                res = _context.sent;

                if (!(!res.ok || res.status < 200 || res.status > 300)) {
                  _context.next = 6;
                  break;
                }

                throw Error("Error fetching oembed: ".concat(res.statusText));

              case 6:
                _context.next = 8;
                return res.json();

              case 8:
                json = _context.sent;
                return _context.abrupt("return", proxy ? JSON.parse(json.contents) : json);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchOEmbed(_x, _x2) {
        return _fetchOEmbed.apply(this, arguments);
      }

      return fetchOEmbed;
    }()
  };

  for (var _i = 0, _Object$entries = Object.entries(runtime); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        fn = _Object$entries$_i[1];

    runtime[key] = fn.bind(runtime);
  }

  return runtime;
};

var createOEmbedElement = function createOEmbedElement(href, proxy) {
  if (typeof window !== 'undefined' && !(SYMBOL in window.top)) {
    Reflect.defineProperty(window.top, SYMBOL, {
      value: spawnRuntime
    });
  }

  return createIframeNode({
    srcdoc: "<script>\n  const symbol = Object.getOwnPropertySymbols(window.top).find(symbol => symbol.description === \"".concat(SYMBOL_NAME, "\");\n  if (symbol === void 0 || !(symbol in window.top)) {\n    throw Error('Runtime chunk not found');\n  }\n\n  const { fetchOEmbed, processOEmbed } = window.top[symbol](window);\n  fetchOEmbed(").concat(JSON.stringify(href), ", ").concat(JSON.stringify(proxy), ").then(oembed => void processOEmbed(oembed, ").concat(JSON.stringify(proxy), "));\n</script>")
  });
};

var getProviderEndpoint = function getProviderEndpoint(linkUrl) {
  var _iterator4 = _createForOfIteratorHelper(providers),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var provider = _step4.value;

      var _iterator5 = _createForOfIteratorHelper(provider.endpoints),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var endpoint = _step5.value;
          if (!('schemes' in endpoint)) continue;

          var _iterator6 = _createForOfIteratorHelper(endpoint.schemes),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var schema = _step6.value;
              schema = schema.replace('*', '.*');
              var regExp = new RegExp(schema);

              if (regExp.test(linkUrl)) {
                return {
                  url: endpoint.url,
                  proxy: 'proxy' in endpoint && endpoint.proxy,
                  query: {
                    format: 'json',
                    url: linkUrl
                  }
                };
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return;
};

var processNode = function processNode(url) {
  var _iterator7 = _createForOfIteratorHelper(customProviders),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var provider = _step7.value;

      var _URL = new URL(url.replace('://www', '://')),
          origin = _URL.origin;

      if (provider.provider_url.replace('://www', '://').startsWith(origin)) {
        return provider.handler(url);
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  var endpoint = getProviderEndpoint(url);

  if (!endpoint) {
    return;
  }

  var endpointUrl = new URL(endpoint.url);

  for (var _i2 = 0, _Object$entries2 = Object.entries(endpoint.query); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    endpointUrl.searchParams.set(key, value);
  }

  return createOEmbedElement(endpointUrl.href, endpoint.proxy);
};

var embed = function embed() {
  return function (tree) {
    visit(tree, function (node) {
      return node.tagName === 'a';
    }, function (node, index, parent) {
      var _a;

      if (parent === null || index === null) return;
      var href = (_a = node.properties) === null || _a === void 0 ? void 0 : _a.href;
      if (!isValidUrl(href)) return;
      var generatedNode = processNode(href);

      if (generatedNode) {
        parent.children[index] = generatedNode;
      }
    });
    return tree;
  };
};

function isValidUrl(url) {
  if (typeof url !== 'string') return false;

  try {
    new URL(url);
    return true;
  } catch (_a) {
    return false;
  }
}

function sanitize(schema) {
  return function transformer(tree) {
    return sanitize$1(tree, schema);
  };
}

var sanitizationSchema = null;

var buildSanitizationSchema = function buildSanitizationSchema() {
  if (!sanitizationSchema) {
    sanitizationSchema = deepmerge(defaultSchema, {
      tagNames: ['tabs', 'tab', 'codegroup', 'button'],
      attributes: {
        '*': ['className', 'style', 'id'],
        code: ['title', 'lineNumbers', 'inline', 'highlightLines', 'lang', 'live', 'jsonSchema', 'http', 'resolved'],
        img: ['bg', 'focus', 'inline', 'invertOnDark'],
        blockquote: ['theme']
      }
    });
    sanitizationSchema.clobber = ['name'];
  }

  return sanitizationSchema;
};

var mdast2React = function mdast2React(input) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var processorInstance = createMdastToHastProcessor(opts).use(rehypeReact, {
    createElement: createElement,
    Fragment: Fragment,
    components: opts.components
  });
  return processorInstance.stringify(processorInstance.runSync(input));
};

var createMdastToHastProcessor = function createMdastToHastProcessor() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return unified().use(remark2rehype, {
    allowDangerousHtml: true,
    handlers: {
      code: codeHandler
    }
  }).use(rehypeRaw).use(sanitize, buildSanitizationSchema()).use(embed).use(opts.rehypePlugins || []).data('settings', opts.settings);
};

var codeHandler = function codeHandler(h, node) {
  var value = node.value ? node.value + '\n' : '';
  var props = {};

  if (node.resolved) {
    props.resolved = typeof node.resolved === 'string' ? node.resolved : JSON.stringify(node.resolved);
  }

  var code = h(node, 'code', props, [u('text', value)]);

  if (node.meta) {
    code.data = {
      meta: node.meta
    };
  }

  return code;
};

var parse = parse$1;

var markdown2React = function markdown2React(input) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var processed = createHastProcessor(opts).use(rehypeReact, {
    createElement: createElement,
    Fragment: Fragment,
    components: opts.components
  }).processSync(input);
  return processed.result;
};

var createHastProcessor = function createHastProcessor() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return unified().use(remarkParse).use(remarkParsePreset).use(opts.remarkPlugins || []).use(remark2rehype, {
    allowDangerousHtml: true,
    handlers: {
      code: codeHandler
    }
  }).use(rehypeRaw).use(sanitize, buildSanitizationSchema()).use(embed).use(opts.rehypePlugins || []).data('settings', opts.settings);
};

function computeToc(tree, maxDepth) {
  var headings = selectAll('root > [type=heading]', tree).map(function (heading) {
    var _a;

    return {
      title: findTitle(heading),
      id: String(((_a = heading.data) === null || _a === void 0 ? void 0 : _a.id) || ''),
      depth: heading.depth
    };
  });
  var root = headings.find(function (item) {
    return item.depth === 1;
  }) || {
    title: 'On this page',
    id: '',
    depth: 1
  };
  var children = headings.filter(function (item) {
    return item.depth > 1 && item.depth <= maxDepth && item.id;
  });
  return [root].concat(_toConsumableArray(children));
}

var findTitle = function findTitle(parent) {
  return selectAll('[type=text]', parent).map(function (textNode) {
    return String(textNode.value);
  }).join(' ');
};

var EMPTY_OBJ$2 = {};

var useMdast2React = function useMdast2React(mdastRoot) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJ$2;
  return React__default.useMemo(function () {
    var o = {
      components: opts.components,
      rehypePlugins: opts.rehypePlugins,
      remarkPlugins: opts.remarkPlugins,
      settings: opts.settings
    };
    return mdast2React(mdastRoot, o);
  }, [mdastRoot, opts.components, opts.rehypePlugins, opts.remarkPlugins, opts.settings]);
};

var useToc = function useToc(mdastRoot, _ref15) {
  var enabled = _ref15.enabled,
      maxDepth = _ref15.maxDepth;
  return React__default.useMemo(function () {
    if (!enabled) return [];
    return computeToc(mdastRoot, maxDepth);
  }, [mdastRoot, enabled, maxDepth]);
};

var MarkdownToc = function MarkdownToc(_ref16) {
  var toc = _ref16.toc,
      container = _ref16.container;

  var _useComponentSize = useComponentSize({
    current: container
  }),
      width = _useComponentSize.width;

  var isMinimal = width <= 768;
  if (!toc) return null;

  if (isMinimal) {
    return React.createElement(MarkdownTocPopover, {
      toc: toc
    });
  }

  return React.createElement(MarkdownTocComponent, {
    toc: toc,
    container: container
  });
};

var MarkdownTocPopover = React.memo(function (_ref17) {
  var toc = _ref17.toc;
  return React.createElement(Box, {
    className: "sl-markdown-viewer-toc",
    pos: "sticky",
    pl: 4,
    top: 4,
    h: "full"
  }, React.createElement(Popover, {
    renderTrigger: React.createElement(Button, {
      size: "sm",
      borderColor: "light",
      icon: ['fas', 'stream']
    }),
    placement: "bottom"
  }, React.createElement(Box, {
    overflowY: "auto",
    overflowX: "hidden",
    style: {
      width: 220
    }
  }, toc.map(function (heading, i) {
    return React.createElement(MarkdownTocLink, {
      key: i,
      item: heading
    });
  }))));
});
var MarkdownTocComponent = React.memo(function (_ref18) {
  var toc = _ref18.toc,
      container = _ref18.container;
  var currentHighlightId = useScrollSpy(toc, container);
  return React.createElement(Box, {
    className: "sl-markdown-viewer-toc",
    pl: 16,
    w: 60
  }, React.createElement(Box, {
    pos: "sticky",
    top: 0
  }, React.createElement(Box, {
    pos: "absolute",
    overflowY: "auto",
    h: "screen",
    w: "full"
  }, React.createElement(Box, {
    py: 8
  }, toc.map(function (heading, i) {
    return React.createElement(MarkdownTocLink, {
      key: i,
      item: heading,
      isSelected: currentHighlightId === heading.id,
      borderL: 2
    });
  })))));
});
var MarkdownTocLink = React.memo(function (_ref19) {
  var item = _ref19.item,
      isSelected = _ref19.isSelected,
      boxProps = _objectWithoutProperties(_ref19, ["item", "isSelected"]);

  return React.createElement(Box, _objectSpread({
    as: "a",
    href: "#".concat(item.id),
    display: "block",
    pr: 2,
    py: 1,
    pl: item.depth === 1 ? 4 : item.depth * 2,
    fontWeight: "medium",
    fontSize: "sm",
    borderColor: isSelected ? 'primary' : 'light',
    color: {
      default: isSelected ? 'primary' : 'muted',
      hover: 'primary-dark'
    },
    textOverflow: "truncate",
    title: item.title
  }, boxProps), item.title);
});

var useScrollSpy = function useScrollSpy(toc, container) {
  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      currentHeadingId = _React$useState4[0],
      setHeadingId = _React$useState4[1];

  var currentEntries = React.useRef({});
  var observer = React.useRef();
  React.useEffect(function () {
    if (observer.current) {
      currentEntries.current = {};
      observer.current.disconnect();
    }

    if (!toc.length || !container || typeof window === 'undefined' || !window.IntersectionObserver) return;
    var sections = [];
    toc.forEach(function (item) {
      try {
        var section = container.querySelector("#".concat(item.id));

        if (section) {
          sections.push(section);
        }
      } catch (_) {}
    });
    if (!sections.length) return;
    observer.current = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target.id) {
          currentEntries.current[entry.target.id] = entry;
        }
      });
      var visibleHeadings = [];
      Object.keys(currentEntries.current).forEach(function (entryId) {
        var headingElement = currentEntries.current[entryId];

        if (headingElement === null || headingElement === void 0 ? void 0 : headingElement.isIntersecting) {
          visibleHeadings.push(headingElement);
        }
      });
      visibleHeadings.sort(function (a, b) {
        return b.time - a.time;
      });

      if (visibleHeadings[0]) {
        setHeadingId(visibleHeadings[0].target.id);
      }
    }, {
      rootMargin: '0px 0px -50%',
      threshold: 1.0
    });
    var currentObserver = observer.current;
    sections.forEach(function (element) {
      return currentObserver.observe(element);
    });
    return function () {
      currentEntries.current = {};
      sections.forEach(function (element) {
        return currentObserver.unobserve(element);
      });
      currentObserver.disconnect();
    };
  }, [toc, container]);
  return currentHeadingId;
};

var MarkdownViewer = function MarkdownViewer(_ref20) {
  var onError = _ref20.onError,
      _ref20$FallbackCompon = _ref20.FallbackComponent,
      FallbackComponent = _ref20$FallbackCompon === void 0 ? MarkdownViewerFallbackComponent : _ref20$FallbackCompon,
      props = _objectWithoutProperties(_ref20, ["onError", "FallbackComponent"]);

  return React__default.createElement(ErrorBoundary, {
    onError: onError,
    FallbackComponent: FallbackComponent
  }, React__default.createElement(MarkdownViewerComponent, _objectSpread({}, props)));
};

MarkdownViewer.displayName = 'MarkdownViewer';
var EMPTY_OBJ$1 = {};

var MarkdownViewerComponent = function MarkdownViewerComponent(_ref21) {
  var markdownOrTree = _ref21.markdown,
      _ref21$parseOptions = _ref21.parseOptions,
      parseOptions = _ref21$parseOptions === void 0 ? {} : _ref21$parseOptions,
      color = _ref21.color,
      _ref21$className = _ref21.className,
      className = _ref21$className === void 0 ? '' : _ref21$className,
      _ref21$includeToc = _ref21.includeToc,
      includeToc = _ref21$includeToc === void 0 ? false : _ref21$includeToc,
      _ref21$tocMaxDepth = _ref21.tocMaxDepth,
      tocMaxDepth = _ref21$tocMaxDepth === void 0 ? 3 : _ref21$tocMaxDepth,
      props = _objectWithoutProperties(_ref21, ["markdown", "parseOptions", "color", "className", "includeToc", "tocMaxDepth"]);

  var contextComponents = useMarkdownViewer().components || EMPTY_OBJ$1;
  var components = (parseOptions === null || parseOptions === void 0 ? void 0 : parseOptions.components) || EMPTY_OBJ$1;
  var componentMapping = React__default.useMemo(function () {
    return _objectSpread({}, DefaultSMDComponents, contextComponents, components);
  }, [components, contextComponents]);
  var mdastTree = useMarkdown2Mdast(markdownOrTree, _objectSpread({}, parseOptions, {
    components: componentMapping
  }));
  var tocTree = useToc(mdastTree, {
    enabled: includeToc,
    maxDepth: tocMaxDepth
  });
  var reactTree = useMdast2React(mdastTree, _objectSpread({}, parseOptions, {
    components: componentMapping
  }));

  var _React__default$useSt = React__default.useState(null),
      _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
      container = _React__default$useSt2[0],
      setContainer = _React__default$useSt2[1];

  if (includeToc && tocTree.length > 1) {
    return React__default.createElement(Flex, {
      ref: setContainer,
      pos: "relative"
    }, React__default.createElement(Prose, _objectSpread({
      className: ['sl-markdown-viewer', className].join(' ')
    }, props, {
      flex: 1,
      overflowY: "auto",
      overflowX: "auto",
      p: 2
    }), reactTree), React__default.createElement(MarkdownToc, {
      toc: tocTree,
      container: container
    }));
  }

  return React__default.createElement(Prose, _objectSpread({
    className: ['sl-markdown-viewer', className].join(' ')
  }, props), reactTree);
};

MarkdownViewerComponent.displayName = 'MarkdownViewer.Component';

var MarkdownViewerFallbackComponent = function MarkdownViewerFallbackComponent(_ref22) {
  var error = _ref22.error;
  return React__default.createElement(Box, {
    p: 4
  }, React__default.createElement("b", null, "Error"), error && ": ".concat(error.message));
};

var EMPTY_OBJ = {};

var useMarkdownTree = function useMarkdownTree(markdownOrTree) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJ;
  return React__default.useMemo(function () {
    var o = {
      components: opts.components,
      rehypePlugins: opts.rehypePlugins,
      remarkPlugins: opts.remarkPlugins,
      settings: opts.settings
    };
    return typeof markdownOrTree === 'string' ? markdown2React(markdownOrTree, o) : mdast2React(markdownOrTree, o);
  }, [markdownOrTree, opts.components, opts.rehypePlugins, opts.remarkPlugins, opts.settings]);
};

export { DEFAULT_MERMAID_SCRIPT_URL, DefaultSMDComponents, MarkdownViewer, MarkdownViewerProvider, buildSanitizationSchema, codeHandler, computeToc, markdown2React, mdast2React, parse, useLoadMermaid, useMarkdownTree, useMarkdownViewer, useRenderMermaid };